/*
  Bland Selv — staged-set builder.
  The set is built in local state (mirrored to localStorage); nothing is
  added to the real cart until the customer clicks "Gå til handlekurv".
  On commit, every staged line is sent in one /cart/add.js call: bundle
  products carry property _bundle_blandselv=true and the free gift (4+
  products) carries _bundle_gift=true, so the hybrid-bundle Shopify Function
  applies the tier discount and zeroes the gift at checkout.
  DOM is built with explicit createElement to avoid HTML-string injection sinks.

  IMPORTANT: the tier percentages (data-tier-*) are display copy only — the real
  discount is applied by the hybrid-bundle Shopify Function. Keep them in sync
  with the Function or the "Du betaler" estimate will disagree with checkout.
*/

(function () {
  const root = document.querySelector('[data-bland-selv]');
  if (!root) return;

  const TIERS = [
    { count: Number(root.dataset.tier2Count || 2), pct: Number(root.dataset.tier2Pct || 20) },
    { count: Number(root.dataset.tier3Count || 3), pct: Number(root.dataset.tier3Pct || 25) },
    { count: Number(root.dataset.tier4Count || 4), pct: Number(root.dataset.tier4Pct || 30) },
  ];
  const LINE_PROP = '_bundle_blandselv';
  const GIFT_PROP = '_bundle_gift';
  const GIFT_THRESHOLD = TIERS[TIERS.length - 1].count; // free gift unlocks at the top tier
  const FREE_SHIP = Number(root.dataset.freeShipping || 0);
  const SVG_NS = 'http://www.w3.org/2000/svg';

  /* ─── Utilities ─────────────────────────────────────────────────────── */
  const krNum = (cents) => Math.round((cents || 0) / 100);
  const fmtKrNum = (kr) => kr.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
  const fmtKr = (cents) => fmtKrNum(krNum(cents));

  const discountFor = (count) => {
    let pct = 0;
    for (const t of TIERS) if (count >= t.count) pct = t.pct;
    return pct;
  };

  const nextTier = (count) => {
    for (const t of TIERS) if (count < t.count) return t;
    return null;
  };

  /* ─── DOM construction helpers (no HTML strings) ────────────────────── */
  function el(tag, attrs, ...children) {
    const node = document.createElement(tag);
    if (attrs) {
      for (const k in attrs) {
        const v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'class') node.className = v;
        else if (k === 'style' && typeof v === 'object') Object.assign(node.style, v);
        else if (k === 'text') node.textContent = String(v);
        else node.setAttribute(k, v === true ? '' : String(v));
      }
    }
    appendChildren(node, children);
    return node;
  }

  function appendChildren(parent, children) {
    for (const c of children) {
      if (c == null || c === false) continue;
      if (Array.isArray(c)) appendChildren(parent, c);
      else if (typeof c === 'string' || typeof c === 'number') {
        parent.appendChild(document.createTextNode(String(c)));
      } else {
        parent.appendChild(c);
      }
    }
  }

  function svgIcon(paths, size) {
    const sz = size || 14;
    const s = document.createElementNS(SVG_NS, 'svg');
    s.setAttribute('width', sz);
    s.setAttribute('height', sz);
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    for (const d of paths) {
      const p = document.createElementNS(SVG_NS, 'path');
      p.setAttribute('d', d);
      s.appendChild(p);
    }
    return s;
  }

  function truckIcon() {
    const s = document.createElementNS(SVG_NS, 'svg');
    s.setAttribute('width', '15');
    s.setAttribute('height', '15');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    const add = (tag, attrs) => {
      const e = document.createElementNS(SVG_NS, tag);
      for (const k in attrs) e.setAttribute(k, attrs[k]);
      s.appendChild(e);
    };
    add('rect', { x: '1', y: '7', width: '14', height: '10', rx: '1.5' });
    add('path', { d: 'M15 10h4l3 3v4h-7' });
    add('circle', { cx: '6', cy: '18.5', r: '2' });
    add('circle', { cx: '18', cy: '18.5', r: '2' });
    return s;
  }

  const icons = {
    plus: () => svgIcon(['M12 5v14M5 12h14']),
    truck: truckIcon,
    minus: () => svgIcon(['M5 12h14']),
    plusSm: () => svgIcon(['M12 5v14M5 12h14'], 12),
    minusSm: () => svgIcon(['M5 12h14'], 12),
    spark: () => svgIcon(['M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z']),
    arrow: () => svgIcon(['M5 12h14M13 5l7 7-7 7'], 16),
    chevDown: () => svgIcon(['M6 9l6 6 6-6'], 16),
    chevUp: () => svgIcon(['M6 15l6-6 6 6'], 16),
    gift: () => svgIcon([
      'M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8',
      'M3 8h18v4H3z',
      'M12 8v13',
      'M12 8C10 8 7 7.6 7 5.6 7 4.2 8.6 4 12 8',
      'M12 8c2 0 5-0.4 5-2.4 0-1.4-1.6-1.6-5 2.4',
    ], 15),
  };

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  /* ─── Staged set ─────────────────────────────────────────────────────
     The set lives in local state and is mirrored to localStorage. Nothing
     reaches the real cart until commitToCart() runs on "Gå til handlekurv". */
  const STORE_KEY = 'gk-bland-selv-set';
  const staged = { items: [] };

  const loadStaged = () => {
    try {
      const raw = localStorage.getItem(STORE_KEY);
      const items = raw ? JSON.parse(raw) : null;
      if (Array.isArray(items)) staged.items = items;
    } catch (e) { /* corrupt or unavailable storage — start empty */ }
  };
  const saveStaged = () => {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(staged.items)); }
    catch (e) { /* storage full or disabled — selection still works in-memory */ }
  };

  // Shaped like /cart.js so the render layer stays unchanged.
  const getCart = async () => ({ items: staged.items });

  const lineKey = (prop, variantId) =>
    (prop === GIFT_PROP ? 'gift:' : 'bs:') + variantId;

  // Add one of `variantId` to the staged set. `data` carries the display
  // fields (price/title/image) read off the product or gift card.
  const addToCart = async (variantId, prop, data) => {
    const propKey = prop || LINE_PROP;
    const key = lineKey(propKey, variantId);
    const existing = staged.items.find((l) => l.key === key);
    if (existing) {
      existing.quantity += 1;
      existing.original_line_price = existing.original_price * existing.quantity;
      return;
    }
    const price = (data && Number(data.price)) || 0;
    staged.items.push({
      key: key,
      variant_id: Number(variantId),
      quantity: 1,
      properties: { [propKey]: 'true' },
      product_title: (data && data.product_title) || '',
      title: (data && data.product_title) || '',
      variant_title: (data && data.variant_title) || '',
      original_price: price,
      original_line_price: price,
      image: (data && data.image) || '',
    });
  };

  // Set a staged line to `quantity` (0 removes it). Mirrors /cart/change.js.
  const changeLine = async (key, quantity) => {
    const idx = staged.items.findIndex((l) => l.key === key);
    if (idx < 0) return;
    if (quantity <= 0) {
      staged.items.splice(idx, 1);
    } else {
      staged.items[idx].quantity = quantity;
      staged.items[idx].original_line_price =
        staged.items[idx].original_price * quantity;
    }
  };

  // Push the whole staged set into the real cart in one request.
  const commitToCart = async () => {
    const items = staged.items
      .filter((l) => l.quantity > 0)
      .map((l) => ({ id: l.variant_id, quantity: l.quantity, properties: l.properties }));
    if (!items.length) return;
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || 'Add failed');
    }
    return r.json();
  };

  /* ─── State derivation ──────────────────────────────────────────────── */
  const bundleLinesFrom = (cart) =>
    (cart.items || []).filter((it) => it.properties && it.properties[LINE_PROP] === 'true');

  const giftLineFrom = (cart) =>
    (cart.items || []).find((it) => it.properties && it.properties[GIFT_PROP] === 'true') || null;

  const totalsFrom = (lines) => {
    const itemCount = lines.reduce((s, l) => s + l.quantity, 0);
    // Base the estimate on ORIGINAL line prices. The bundle discount is applied
    // later by the Shopify Function, so using final_line_price would
    // double-count it if the cart ever surfaces the automatic discount.
    const subtotal = lines.reduce(
      (s, l) => s + (l.original_line_price != null ? l.original_line_price : l.final_line_price), 0);
    const pct = discountFor(itemCount);
    const discount = Math.round((subtotal * pct) / 100);
    const total = subtotal - discount;
    const subKr = krNum(subtotal);
    const totKr = krNum(total);
    return { itemCount, pct, subtotal, total, subKr, totKr, saveKr: subKr - totKr };
  };

  /* ─── DOM refs ──────────────────────────────────────────────────────── */
  const refs = {
    cards: () => root.querySelectorAll('[data-bs-card]'),
    tabs: root.querySelectorAll('[data-bs-tab]'),
    progHeadline: root.querySelector('[data-bs-prog-headline]'),
    progHint: root.querySelector('[data-bs-prog-hint]'),
    barFill: root.querySelector('[data-bs-bar-fill]'),
    ticks: root.querySelectorAll('[data-bs-tick]'),
    summaryCount: root.querySelector('[data-bs-summary-count]'),
    summaryBody: root.querySelector('[data-bs-summary-body]'),
    summaryFoot: root.querySelector('[data-bs-summary-foot]'),
    summaryTotals: root.querySelector('[data-bs-summary-totals]'),
    summaryShip: root.querySelector('[data-bs-summary-ship]'),
    summaryGiftTeaser: root.querySelector('[data-bs-summary-gift-teaser]'),
    checkout: root.querySelector('[data-bs-checkout]'),
    checkoutLabel: root.querySelector('[data-bs-checkout-label]'),
    mbar: root.querySelector('[data-bs-mbar]'),
    mbarFill: root.querySelector('[data-bs-mbar-fill]'),
    mbarTicks: root.querySelectorAll('[data-bs-mbar-tick]'),
    mbarCount: root.querySelector('[data-bs-mbar-count]'),
    mbarHeadline: root.querySelector('[data-bs-mbar-headline]'),
    mbarSub: root.querySelector('[data-bs-mbar-sub]'),
    mbarPanel: root.querySelector('[data-bs-mbar-panel]'),
    mbarPanelBody: root.querySelector('[data-bs-mbar-panel-body]'),
    mbarToggle: root.querySelector('[data-bs-mbar-toggle]'),
    mbarChevron: root.querySelector('[data-bs-mbar-chevron]'),
    mbarCta: root.querySelector('[data-bs-mbar-cta]'),
    mbarCtaLabel: root.querySelector('[data-bs-mbar-cta-label]'),
    live: root.querySelector('[data-bs-live]'),
    toast: root.querySelector('[data-bs-toast]'),
    giftSection: root.querySelector('[data-bs-gift]'),
    giftSub: root.querySelector('[data-bs-gift-sub]'),
    giftCards: () => root.querySelectorAll('[data-bs-gift-card]'),
  };

  /* ─── Feedback: screen-reader announcements + error toast ───────────── */
  const announce = (msg) => { if (refs.live) refs.live.textContent = msg; };

  let toastTimer = null;
  const showError = (msg) => {
    if (!refs.toast) return;
    refs.toast.textContent = msg;
    refs.toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { refs.toast.hidden = true; }, 5000);
  };

  /* ─── Focus restoration across re-renders ───────────────────────────── */
  const captureFocusId = () => {
    const a = document.activeElement;
    return a && a.dataset && a.dataset.focusId ? a.dataset.focusId : null;
  };
  const restoreFocus = (fid) => {
    if (!fid) return;
    let target = root.querySelector('[data-focus-id="' + fid + '"]');
    if (!target) {
      const parts = fid.split('|'); // [kind, scope, id, dir]
      const kind = parts[0], scope = parts[1], id = parts[2];
      if (kind === 'add') {
        target = root.querySelector('[data-focus-id="step|card|' + id + '|inc"]');
      } else if (kind === 'step' && scope === 'card') {
        target = root.querySelector('[data-focus-id="add|card|' + id + '|"]');
      } else if (kind === 'step' && scope === 'mbar') {
        target = refs.mbarToggle;
      }
    }
    if (target) {
      try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
    }
  };

  const setCta = (link, labelEl, enabled, label) => {
    link.classList.toggle('is-disabled', !enabled);
    if (enabled) {
      link.removeAttribute('aria-disabled');
      link.setAttribute('href', '/cart');
    } else {
      link.setAttribute('aria-disabled', 'true');
      link.removeAttribute('href');
    }
    clear(labelEl);
    if (typeof label === 'string') {
      labelEl.textContent = label;
    } else {
      appendChildren(labelEl, label);
    }
  };

  const ctaLabelWithPrice = (intro, totKr) => [
    intro + ' ',
    el('span', { class: 'gk-cta-price' }, fmtKrNum(totKr)),
  ];

  /* Open the theme's cart drawer (the set is already in the cart). The theme's
     <cart-drawer> re-renders and slides open on `cart:refresh` { open: true }.
     Falls back to the cart page on themes that render the cart as a page. */
  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.show !== 'function') {
      window.location.href = '/cart';
      return;
    }
    document.dispatchEvent(
      new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
    );
  };

  /* ─── Stepper builders ──────────────────────────────────────────────── */
  function buildStepper(line, classes, stepAttr, scope) {
    const id = scope === 'card' ? line.variant_id : line.key;
    const fid = (dir) => 'step|' + scope + '|' + id + '|' + dir;
    const sm = classes.indexOf('sm') >= 0;
    const dec = el(
      'button',
      { type: 'button', [stepAttr]: '-1', 'data-bs-key': line.key,
        'data-focus-id': fid('dec'), 'aria-label': 'Mindre' },
      sm ? icons.minusSm() : icons.minus()
    );
    const inc = el(
      'button',
      { type: 'button', [stepAttr]: '+1', 'data-bs-key': line.key,
        'data-focus-id': fid('inc'), 'aria-label': 'Mer' },
      sm ? icons.plusSm() : icons.plus()
    );
    const val = el('span', { class: 'gk-stepper-val' }, String(line.quantity));
    return el('div', { class: classes, role: 'group', 'aria-label': 'Antall' }, dec, val, inc);
  }

  function buildSumStep(line) {
    const fid = (dir) => 'step|sum|' + line.key + '|' + dir;
    return el(
      'div',
      { class: 'gk-sum-step' },
      el(
        'button',
        { type: 'button', 'data-bs-sum-step': '-1', 'data-bs-key': line.key,
          'data-focus-id': fid('dec'), 'aria-label': 'Mindre' },
        icons.minusSm()
      ),
      el('span', null, String(line.quantity)),
      el(
        'button',
        { type: 'button', 'data-bs-sum-step': '+1', 'data-bs-key': line.key,
          'data-focus-id': fid('inc'), 'aria-label': 'Mer' },
        icons.plusSm()
      )
    );
  }

  /* ─── Renderers ─────────────────────────────────────────────────────── */
  let summaryPopulated = false;
  let mbarPopulated = false;

  const renderProgress = ({ itemCount, pct }) => {
    const next = nextTier(itemCount);
    const target = next ? next.count : TIERS[TIERS.length - 1].count;
    const fill = Math.min(itemCount / target, 1) * 100;

    if (refs.barFill) refs.barFill.style.width = fill + '%';
    if (refs.mbarFill) refs.mbarFill.style.width = fill + '%';

    refs.ticks.forEach((tick) => {
      tick.classList.toggle('reached', itemCount >= Number(tick.dataset.bsTick));
    });
    refs.mbarTicks.forEach((tick) => {
      tick.classList.toggle('reached', itemCount >= Number(tick.dataset.bsMbarTick));
    });

    if (refs.progHeadline) {
      refs.progHeadline.textContent = itemCount === 0
        ? 'Velg minst ' + TIERS[0].count + ' produkter og spar ' + TIERS[0].pct + '%'
        : 'Du sparer ' + pct + '% · ' + itemCount + ' i settet';
    }
    if (refs.progHint) {
      if (next) {
        const giftBonus = next.count === GIFT_THRESHOLD ? ' + gratis gave' : '';
        refs.progHint.textContent =
          'Legg til ' + (next.count - itemCount) + ' til = ' + next.pct + '%' + giftBonus;
      } else {
        refs.progHint.textContent = 'Maks rabatt + gratis gave 🎁';
      }
    }
  };

  const renderCardStates = (lines) => {
    const byVariant = new Map();
    lines.forEach((l) => byVariant.set(String(l.variant_id), l));

    refs.cards().forEach((card) => {
      const vid = card.dataset.variantId;
      const line = byVariant.get(vid);
      const action = card.querySelector('[data-bs-action]');
      const check = card.querySelector('[data-bs-check]');
      if (!action) return;
      // Sold-out / on-sale products are rendered by Liquid and can't join the
      // bundle — never replace their action slot.
      if (action.querySelector('.gk-add-btn[disabled]:not([data-bs-add]), .gk-card-note')) {
        return;
      }
      clear(action);
      if (line && line.quantity > 0) {
        card.classList.add('selected');
        if (check) check.hidden = false;
        action.appendChild(buildStepper(line, 'gk-stepper', 'data-bs-step', 'card'));
      } else {
        card.classList.remove('selected');
        if (check) check.hidden = true;
        action.appendChild(
          el('button',
            { class: 'gk-add-btn', 'data-bs-add': '', type: 'button',
              'data-focus-id': 'add|card|' + vid + '|' },
            icons.plus(), ' Legg til')
        );
      }
    });
  };

  const buildLadder = () => {
    const rung = (n, pct, top) =>
      el('div', { class: 'gk-ladder-rung' + (top ? ' is-top' : '') },
        el('b', null, n),
        el('span', null, 'produkter'),
        top ? el('span', { class: 'gk-ladder-gift' }, icons.gift(), 'gave') : null,
        el('span', { class: 'gk-ladder-pct' }, '−' + pct + '%')
      );
    return el('div', { class: 'gk-empty' },
      el('p', { class: 'gk-empty-lead' }, 'Mengderabatt — spar mer for hvert produkt'),
      el('div', { class: 'gk-ladder' },
        rung(String(TIERS[0].count), TIERS[0].pct, false),
        rung(String(TIERS[1].count), TIERS[1].pct, false),
        rung(TIERS[2].count + '+', TIERS[2].pct, true)
      ),
      el('p', { class: 'gk-empty-hint' },
        'Trykk «Legg til» på produktene du vil ha — rabatten trekkes automatisk i kassen.')
    );
  };

  /* Total — figures pre-rounded by totalsFrom() so struck − saved = paid. */
  const buildTotalBlock = ({ pct, subKr, totKr, saveKr }) => {
    const block = el('div', { class: 'gk-total' },
      el('div', { class: 'gk-total-main' },
        el('span', { class: 'gk-total-lbl' }, 'Du betaler'),
        el('strong', { class: 'gk-total-amt' }, fmtKrNum(totKr))
      )
    );
    if (pct > 0) {
      block.appendChild(
        el('div', { class: 'gk-total-sub' },
          el('span', { class: 'gk-total-was' }, fmtKrNum(subKr)),
          el('span', { class: 'gk-total-save' }, 'Spar ' + fmtKrNum(saveKr) + ' · −' + pct + '%')
        )
      );
    }
    return block;
  };

  const buildNudgeLine = (next, itemCount) => {
    const left = next.count - itemCount;
    return el('div', { class: 'gk-nudge-line' },
      icons.spark(),
      el('span', null,
        'Legg til ',
        el('strong', null, left + (left === 1 ? ' produkt' : ' produkter')),
        ' for ',
        el('strong', null, '−' + next.pct + '%')
      )
    );
  };

  const buildShipSlim = (amount) => {
    if (!FREE_SHIP || FREE_SHIP <= 0) return null;
    const remaining = FREE_SHIP - amount;
    const fill = Math.min(amount / FREE_SHIP, 1) * 100;
    const free = remaining <= 0;
    const row = free
      ? el('div', { class: 'gk-ship-slim-row' }, icons.truck(),
          el('span', null, el('strong', null, 'Fri frakt'), ' er låst opp 🎉'))
      : el('div', { class: 'gk-ship-slim-row' }, icons.truck(),
          el('span', null, el('strong', null, fmtKr(remaining)), ' igjen til fri frakt'));
    return el('div', { class: 'gk-ship-slim' + (free ? ' is-free' : '') },
      row,
      free ? null : el('div', { class: 'gk-ship-slim-bar' },
        el('div', { class: 'gk-ship-slim-fill', style: { width: fill + '%' } })
      )
    );
  };

  const giftDisplayName = (line) => {
    let name = line.product_title || line.title || 'Gave';
    if (line.variant_title && line.variant_title !== 'Default Title') {
      name += ' ' + line.variant_title;
    }
    return name;
  };

  const buildGiftLine = (line) =>
    el('div', { class: 'gk-gift-line' },
      icons.gift(),
      el('span', { class: 'gk-gift-line-name' },
        el('strong', null, giftDisplayName(line)),
        el('span', null, 'Din gave')
      ),
      el('span', { class: 'gk-gift-line-free' }, 'Gratis')
    );

  /* Gift promo banner for the summary / mobile sheet — surfaces the gift and
     scroll-links down to the picker. Hidden once a gift has been chosen
     (buildGiftLine then shows the choice instead). */
  const buildGiftTeaser = (totals, cart) => {
    if (!refs.giftSection || giftLineFrom(cart)) return null;
    const locked = totals.itemCount < GIFT_THRESHOLD;
    let title, sub;
    if (locked) {
      const left = GIFT_THRESHOLD - totals.itemCount;
      title = 'Gratis gave ved ' + GIFT_THRESHOLD + ' produkter';
      sub = left + ' produkt' + (left === 1 ? '' : 'er') + ' igjen — se gavene';
    } else {
      title = 'Din gratis gave er klar!';
      sub = 'Velg gaven din';
    }
    return el('button',
      { type: 'button', class: 'gk-gift-promo ' + (locked ? 'is-locked' : 'is-ready'),
        'data-bs-gift-scroll': '' },
      el('span', { class: 'gk-gift-promo-icon' }, icons.gift()),
      el('span', { class: 'gk-gift-promo-text' },
        el('strong', null, title),
        el('span', null, sub)
      ),
      el('span', { class: 'gk-gift-promo-arrow' }, icons.arrow())
    );
  };

  const renderSummary = (lines, totals, cart) => {
    const { itemCount } = totals;
    const next = nextTier(itemCount);
    const enter = !summaryPopulated && lines.length > 0;
    summaryPopulated = lines.length > 0;

    refs.summaryCount.textContent = itemCount === 0
      ? 'Tomt — velg produkter under'
      : itemCount + ' produkt' + (itemCount === 1 ? '' : 'er') + ' i settet';

    clear(refs.summaryBody);
    clear(refs.summaryTotals);
    clear(refs.summaryShip);
    if (refs.summaryGiftTeaser) clear(refs.summaryGiftTeaser);

    if (itemCount === 0) {
      refs.summaryBody.appendChild(buildLadder());
      refs.summaryFoot.hidden = true;
      refs.checkout.hidden = true;
      // Reset the label so a price from a previous set can never linger.
      setCta(refs.checkout, refs.checkoutLabel, false,
        'Velg ' + TIERS[0].count + ' produkter for ' + TIERS[0].pct + '% rabatt');
      return;
    }

    const list = el('div', { class: 'gk-sum-list' });
    lines.forEach((l, i) => {
      const thumb = el('div', { class: 'gk-sum-thumb' });
      if (l.image) thumb.appendChild(el('img', { src: l.image, alt: '', loading: 'lazy' }));
      list.appendChild(
        el('div',
          { class: 'gk-sum-item' + (enter ? ' is-enter' : ''),
            style: enter ? 'animation-delay:' + (i * 30) + 'ms' : null },
          thumb,
          el('div', { class: 'gk-sum-name' },
            el('strong', null, l.product_title),
            el('span', null, fmtKr(l.original_price) + ' × ' + l.quantity)
          ),
          buildSumStep(l)
        )
      );
    });
    refs.summaryBody.appendChild(list);

    const gift = giftLineFrom(cart);
    if (gift) refs.summaryBody.appendChild(buildGiftLine(gift));

    refs.summaryFoot.hidden = false;
    if (next) refs.summaryTotals.appendChild(buildNudgeLine(next, itemCount));
    const totalEl = buildTotalBlock(totals);
    if (enter) totalEl.classList.add('is-enter');
    refs.summaryTotals.appendChild(totalEl);

    const ship = buildShipSlim(totals.total);
    if (ship) refs.summaryShip.appendChild(ship);

    const teaser = buildGiftTeaser(totals, cart);
    if (teaser && refs.summaryGiftTeaser) refs.summaryGiftTeaser.appendChild(teaser);

    refs.checkout.hidden = false;
    if (itemCount < TIERS[0].count) {
      const left = TIERS[0].count - itemCount;
      setCta(refs.checkout, refs.checkoutLabel, false,
        'Velg ' + left + ' produkt' + (left === 1 ? '' : 'er') + ' til for ' + TIERS[0].pct + '% rabatt');
    } else {
      setCta(refs.checkout, refs.checkoutLabel, true,
        ctaLabelWithPrice('Gå til handlekurv', totals.totKr));
    }
  };

  const renderMobileBar = (lines, totals, cart) => {
    const { itemCount, pct, saveKr } = totals;
    const next = nextTier(itemCount);
    const enter = !mbarPopulated && lines.length > 0;
    mbarPopulated = lines.length > 0;

    refs.mbarCount.classList.toggle('empty', itemCount === 0);
    clear(refs.mbarCount);
    if (itemCount === 0) refs.mbarCount.appendChild(icons.spark());
    else refs.mbarCount.textContent = String(itemCount);

    const gift = giftLineFrom(cart);
    let main, sub;
    if (itemCount === 0) {
      main = 'Legg til ' + TIERS[0].count + ' og spar ' + TIERS[0].pct + '%';
      sub = 'Bygg settet ditt';
    } else if (next) {
      const giftBonus = next.count === GIFT_THRESHOLD ? ' + gave' : '';
      main = 'Legg til ' + (next.count - itemCount) + ' til = spar ' + next.pct + '%' + giftBonus;
      sub = pct > 0
        ? 'Sparer ' + fmtKrNum(saveKr) + ' nå (−' + pct + '%)'
        : itemCount + ' i settet · ingen rabatt enda';
    } else {
      main = 'Du sparer ' + fmtKrNum(saveKr) + ' 🎉';
      sub = gift
        ? '🎁 ' + giftDisplayName(gift) + ' · din gave'
        : '🎁 Velg din gratis gave';
    }
    refs.mbarHeadline.textContent = main;
    refs.mbarSub.textContent = sub;

    clear(refs.mbarPanelBody);
    if (lines.length === 0) {
      refs.mbarPanelBody.appendChild(
        el('p', { class: 'gk-mbar-empty' }, 'Bla i produktene og trykk + for å legge i settet.')
      );
    } else {
      const list = el('div', { class: 'gk-mbar-list' });
      lines.forEach((l, i) => {
        const thumb = el('div', { class: 'gk-mbar-thumb' });
        if (l.image) thumb.appendChild(el('img', { src: l.image, alt: '', loading: 'lazy' }));
        list.appendChild(
          el('div',
            { class: 'gk-mbar-item' + (enter ? ' is-enter' : ''),
              style: enter ? 'animation-delay:' + (i * 30) + 'ms' : null },
            thumb,
            el('div', { class: 'gk-mbar-name' },
              el('strong', null, l.product_title),
              el('span', null, fmtKr(l.original_price))
            ),
            buildStepper(l, 'gk-stepper sm', 'data-bs-sum-step', 'mbar')
          )
        );
      });
      refs.mbarPanelBody.appendChild(list);

      if (gift) refs.mbarPanelBody.appendChild(buildGiftLine(gift));

      if (next) refs.mbarPanelBody.appendChild(buildNudgeLine(next, itemCount));
      const totalEl = buildTotalBlock(totals);
      if (enter) totalEl.classList.add('is-enter');
      refs.mbarPanelBody.appendChild(totalEl);
      const shipM = buildShipSlim(totals.total);
      if (shipM) refs.mbarPanelBody.appendChild(shipM);
      const giftTeaser = buildGiftTeaser(totals, cart);
      if (giftTeaser) refs.mbarPanelBody.appendChild(giftTeaser);
    }

    if (itemCount < TIERS[0].count) {
      const left = Math.max(TIERS[0].count - itemCount, 1);
      setCta(refs.mbarCta, refs.mbarCtaLabel, false,
        'Velg ' + left + ' til for ' + TIERS[0].pct + '% rabatt');
    } else {
      setCta(refs.mbarCta, refs.mbarCtaLabel, true,
        ctaLabelWithPrice('Gå til handlekurv', totals.totKr));
    }
  };

  /* ─── Free gift ─────────────────────────────────────────────────────── */
  // The variant a gift card would add: its own variant, or the chosen size.
  const giftCardVariant = (card) => {
    if (card.dataset.multi === 'true') {
      const sel = card.querySelector('[data-bs-gift-size]');
      return sel ? sel.value : null;
    }
    return card.dataset.variantId || null;
  };
  // Whether a gift card represents the variant currently in the cart.
  const giftCardOwnsVariant = (card, vid) => {
    if (!vid) return false;
    if (card.dataset.multi === 'true') {
      return !!card.querySelector('[data-bs-gift-size] option[value="' + vid + '"]');
    }
    return card.dataset.variantId === vid;
  };

  // Display fields for the gift a card represents (its size option if multi).
  const giftCardData = (card) => {
    if (card.dataset.multi === 'true') {
      const sel = card.querySelector('[data-bs-gift-size]');
      const opt = sel && sel.selectedOptions[0];
      return {
        price: opt ? opt.dataset.price : 0,
        product_title: opt ? opt.dataset.title : '',
        variant_title: '',
        image: card.dataset.image || '',
      };
    }
    return {
      price: card.dataset.price || 0,
      product_title: card.dataset.title || '',
      variant_title: '',
      image: card.dataset.image || '',
    };
  };

  // Reconcile the staged set's single gift line (null = remove the gift).
  const setGift = async (variantId, data) => {
    staged.items = staged.items.filter(
      (l) => !(l.properties && l.properties[GIFT_PROP] === 'true'));
    if (variantId) await addToCart(variantId, GIFT_PROP, data);
  };

  const renderGift = (totals, cart) => {
    if (!refs.giftSection) return;
    const locked = totals.itemCount < GIFT_THRESHOLD;
    refs.giftSection.classList.toggle('is-locked', locked);

    const gift = giftLineFrom(cart);
    const selectedVid = gift ? String(gift.variant_id) : null;

    if (refs.giftSub) {
      if (locked) {
        const left = GIFT_THRESHOLD - totals.itemCount;
        refs.giftSub.textContent = 'Legg til ' + left + ' produkt' + (left === 1 ? '' : 'er') +
          ' til i settet for å låse opp en gratis gave.';
      } else if (selectedVid) {
        refs.giftSub.textContent = 'Gaven din er lagt til — du kan bytte når som helst.';
      } else {
        refs.giftSub.textContent = 'Du har låst opp en gratis gave — velg din favoritt.';
      }
    }

    refs.giftCards().forEach((card) => {
      const btn = card.querySelector('[data-bs-gift-pick]');
      const sel = card.querySelector('[data-bs-gift-size]');
      const owns = giftCardOwnsVariant(card, selectedVid);
      card.classList.toggle('selected', owns);
      if (sel) {
        sel.disabled = locked;
        if (owns && selectedVid) sel.value = selectedVid;
      }
      if (btn) {
        // Single source of truth: the cart's gift line. Fully reset every
        // button each render — clear the transient pending state and only
        // disable when the whole section is locked (never per-selection).
        btn.classList.remove('is-busy');
        btn.disabled = locked;
        btn.setAttribute('aria-pressed', String(owns));
        btn.textContent = owns ? 'Valgt' : 'Velg';
      }
    });
  };

  /* ─── Main refresh ──────────────────────────────────────────────────── */
  let announceNext = false;
  const refresh = async () => {
    try {
      let cart = await getCart();
      let lines = bundleLinesFrom(cart);
      let totals = totalsFrom(lines);
      // The free gift is only valid at the top tier — drop it if the set shrank.
      const gift = giftLineFrom(cart);
      if (gift && totals.itemCount < GIFT_THRESHOLD) {
        await changeLine(gift.key, 0);
        cart = await getCart();
        lines = bundleLinesFrom(cart);
        totals = totalsFrom(lines);
      }
      renderProgress(totals);
      renderCardStates(lines);
      renderSummary(lines, totals, cart);
      renderMobileBar(lines, totals, cart);
      renderGift(totals, cart);
      saveStaged();
      if (announceNext) {
        announce(totals.itemCount === 0
          ? 'Settet er tomt.'
          : totals.itemCount + ' i settet. Du betaler ' + fmtKrNum(totals.totKr) + '.');
      }
    } catch (e) {
      console.error('[bland-selv] refresh failed', e);
      showError('Kunne ikke oppdatere settet. Sjekk nettforbindelsen og prøv igjen.');
    } finally {
      announceNext = false;
    }
  };

  /* ─── Mobile bar open/close ─────────────────────────────────────────── */
  const setMbarOpen = (open) => {
    refs.mbar.classList.toggle('open', open);
    refs.mbarPanel.classList.toggle('open', open);
    if ('inert' in HTMLElement.prototype) refs.mbarPanel.inert = !open;
    refs.mbarToggle.setAttribute('aria-expanded', String(open));
    clear(refs.mbarChevron);
    const ic = open ? icons.chevDown() : icons.chevUp();
    while (ic.firstChild) refs.mbarChevron.appendChild(ic.firstChild);
  };

  /* Smooth-scroll to the gift picker (and close the mobile sheet if open). */
  const scrollToGift = () => {
    if (refs.mbar.classList.contains('open')) setMbarOpen(false);
    if (!refs.giftSection) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    refs.giftSection.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  };

  /* ─── Event delegation ──────────────────────────────────────────────── */
  root.addEventListener('click', async (ev) => {
    const add = ev.target.closest('[data-bs-add]');
    const step = ev.target.closest('[data-bs-step]');
    const sumStep = ev.target.closest('[data-bs-sum-step]');
    const tab = ev.target.closest('[data-bs-tab]');
    const mbarToggle = ev.target.closest('[data-bs-mbar-toggle]');
    const checkout = ev.target.closest('[data-bs-checkout], [data-bs-mbar-cta]');
    const giftPick = ev.target.closest('[data-bs-gift-pick]');
    const giftScroll = ev.target.closest('[data-bs-gift-scroll]');
    const focusId = captureFocusId();

    if (giftScroll) {
      ev.preventDefault();
      scrollToGift();
      return;
    }

    if (checkout) {
      ev.preventDefault();
      if (checkout.getAttribute('aria-disabled') === 'true' || !checkout.getAttribute('href')) return;
      if (!staged.items.length || checkout.classList.contains('is-busy')) return;
      checkout.classList.add('is-busy');
      try {
        await commitToCart();
        staged.items = [];
        saveStaged();
        openCartDrawer();
        await refresh();
      } catch (err) {
        console.error('[bland-selv] checkout failed', err);
        showError('Kunne ikke gå til handlekurv. Prøv igjen.');
      } finally {
        checkout.classList.remove('is-busy');
      }
      return;
    }

    if (add) {
      ev.preventDefault();
      const card = add.closest('[data-bs-card]');
      add.disabled = true;
      add.classList.add('is-busy');
      try {
        await addToCart(card.dataset.variantId, LINE_PROP, {
          price: card.dataset.price,
          product_title: card.dataset.title,
          image: card.dataset.image,
        });
        announceNext = true;
        await refresh();
        restoreFocus(focusId);
      } catch (err) {
        add.disabled = false;
        add.classList.remove('is-busy');
        console.error('[bland-selv] add failed', err);
        showError('Kunne ikke legge til produktet. Prøv igjen.');
      }
      return;
    }

    if (step || sumStep) {
      ev.preventDefault();
      const btn = step || sumStep;
      const delta = Number(btn.dataset.bsStep || btn.dataset.bsSumStep);
      const key = btn.dataset.bsKey;
      const valEl = btn.parentElement.querySelector('.gk-stepper-val, span');
      const current = Number(valEl ? valEl.textContent : 0);
      const target = Math.max(0, current + delta);
      const stepper = btn.closest('.gk-stepper, .gk-sum-step');
      btn.disabled = true;
      if (stepper) stepper.classList.add('is-busy');
      try {
        await changeLine(key, target);
        announceNext = true;
        await refresh();
        restoreFocus(focusId);
      } catch (err) {
        btn.disabled = false;
        if (stepper) stepper.classList.remove('is-busy');
        console.error('[bland-selv] step failed', err);
        showError('Kunne ikke oppdatere antallet. Prøv igjen.');
        await refresh();
      }
      return;
    }

    if (giftPick) {
      ev.preventDefault();
      if (giftPick.disabled) return;
      const card = giftPick.closest('[data-bs-gift-card]');
      const variant = giftCardVariant(card);
      if (!variant) return;
      const alreadyChosen = giftPick.getAttribute('aria-pressed') === 'true';
      giftPick.disabled = true;
      giftPick.classList.add('is-busy');
      try {
        await setGift(alreadyChosen ? null : variant, alreadyChosen ? null : giftCardData(card));
        announceNext = true;
        await refresh();
      } catch (err) {
        giftPick.disabled = false;
        giftPick.classList.remove('is-busy');
        console.error('[bland-selv] gift failed', err);
        showError('Kunne ikke oppdatere gaven. Prøv igjen.');
      }
      return;
    }

    if (tab) {
      ev.preventDefault();
      const target = tab.dataset.bsTab;
      refs.tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-pressed', String(isActive));
      });
      refs.cards().forEach((card) => {
        const show = target === 'alle' || card.dataset.type === target;
        card.style.display = show ? '' : 'none';
      });
      return;
    }

    if (mbarToggle) {
      ev.preventDefault();
      setMbarOpen(!refs.mbar.classList.contains('open'));
    }
  });

  // Changing a gift size only writes to the cart if that gift is the chosen one.
  root.addEventListener('change', async (ev) => {
    const sizeSel = ev.target.closest('[data-bs-gift-size]');
    if (!sizeSel) return;
    const card = sizeSel.closest('[data-bs-gift-card]');
    if (!card || !card.classList.contains('selected')) return;
    try {
      await setGift(sizeSel.value, giftCardData(card));
      announceNext = true;
      await refresh();
    } catch (err) {
      console.error('[bland-selv] gift size failed', err);
      showError('Kunne ikke oppdatere gaven. Prøv igjen.');
    }
  });

  // Dismiss the mobile panel by tapping outside it or pressing Escape.
  document.addEventListener('click', (ev) => {
    if (refs.mbar.classList.contains('open') && !ev.target.closest('[data-bs-mbar]')) {
      setMbarOpen(false);
    }
  });
  document.addEventListener('keydown', (ev) => {
    if (ev.key === 'Escape' && refs.mbar.classList.contains('open')) {
      setMbarOpen(false);
      refs.mbarToggle.focus();
    }
  });

  /* Hide the mobile bar while the theme's cart drawer is open — the fixed bar
     (z-index 50) would otherwise sit on top of the drawer (z-index 30). */
  const cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl && refs.mbar) {
    const syncMbarToDrawer = () => {
      const drawerOpen = cartDrawerEl.hasAttribute('open');
      refs.mbar.classList.toggle('is-drawer-open', drawerOpen);
      if (drawerOpen) setMbarOpen(false);
    };
    new MutationObserver(syncMbarToDrawer).observe(cartDrawerEl, {
      attributes: true,
      attributeFilter: ['open', 'class'],
    });
    syncMbarToDrawer();
  }

  /* ─── Init ──────────────────────────────────────────────────────────── */
  if ('inert' in HTMLElement.prototype && refs.mbarPanel) refs.mbarPanel.inert = true;
  loadStaged();
  refresh();
})();